import { Tooltip } from "@/atoms"
import { RiskTooltipContent } from "./RiskTooltipContent"

import styles from "./RiskTooltip.module.scss"

import type { RiskTooltipProps } from "."

export const RiskTooltip: React.FC<RiskTooltipProps> = (props) => {
  const { record, children, placement, title, open } = props

  return (
    <Tooltip
      open={open}
      overlayClassName={styles.tooltip}
      title={() => {
        if (title) return title
        if (!record) return null

        const { riskId, publishedOn, aliases } = record

        return (
          <RiskTooltipContent
            riskId={riskId}
            publishedOn={publishedOn}
            aliases={aliases}
          />
        )
      }}
      placement={placement}
    >
      {children}
    </Tooltip>
  )
}
